import { dictionary } from "@/schemas/dictionary";
import { z } from "@/zod";

const agreementCompany = dictionary.extend({
  full_name: z.string().optional(),
  description: z.string().min(1),
});

export const agreementCompanyRead = agreementCompany.readonly();
export const agreementCompanyCreate = agreementCompany.omit({ id: true });
export const agreementCompanyUpdate = agreementCompanyCreate.partial();
